module.exports = __webpack_public_path__ + "media/src/site/images/logo-ee2e8c5fdedd3811409919d20f38e872.svg";